import React from 'react'
import modalIcon from '../Assets/schedule/modalIcon.svg'
import crossIcon from '../Assets/schedule/cross.svg'

const SavingModal = ({ visible, onConfirm, onCancel, title = 'Confirm', message = 'Are you sure you want to save the changes?', confirmText = 'YES', cancelText = 'NO' }) => {
  if (!visible) return null

  const overlayStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 100000,
  }

  const modalStyle = {
    width: 583,
    height: 416,
    borderRadius: 24,
    background: '#FFFFFF',
    position: 'relative',
    padding: 32,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  }

  const crossStyle = {
    position: 'absolute',
    right: 32,
    top: 32,
    width: 16,
    height: 16,
    cursor: 'pointer',
    opacity: 1,
  }

  const iconWrap = {
    width: 120,
    height: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8,
    // No borderRadius/overflow:hidden here - the illustration is already a
    // full 120x120 scene (incl. decorative shapes that reach its corners),
    // so a circular clip was cropping those corner shapes off instead of
    // showing the complete illustration the spec calls for.
  }

  const titleStyle = {
    fontFamily: 'Roboto',
    fontSize: 24,
    fontWeight: 500,
    color: '#191919',
    marginTop: 28,
    textAlign: 'center',
  }

  const messageStyle = {
    fontFamily: 'Roboto',
    color: '#636363',
    fontSize: 16,
    fontWeight: 400,
    width: 440,
    textAlign: 'center',
    marginTop: 20,
  }

  const buttonsRow = {
    display: 'flex',
    gap: 25,
    marginBottom: 8,
  }

  const noBtn = {
    width: 223,
    height: 45,
    borderRadius: 12,
    border: '1px solid #AEAEAE',
    background: '#FFFFFF',
    color: '#AEAEAE',
    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 700,
  }

  const yesBtn = {
    width: 223,
    height: 45,
    borderRadius: 12,
    border: 'none',
    background: '#594099',
    color: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 700,
  }

  const handleOverlayClick = (e) => {
    if (onCancel) onCancel()
  }

  const stopPropagation = (e) => {
    e.stopPropagation()
  }

  return (
    <div style={overlayStyle} onClick={handleOverlayClick}>
      <div style={modalStyle} role="dialog" aria-modal="true" onClick={stopPropagation}>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <img src={crossIcon} style={crossStyle} onClick={onCancel} alt="close" />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <div style={iconWrap}><img src={modalIcon} alt="modal" style={{ width: 120, height: 120, display: 'block' }} /></div>
          <div style={titleStyle}>{title}</div>
          <div style={messageStyle}>{message}</div>
        </div>

        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <div style={buttonsRow}>
            <button type="button" style={noBtn} onClick={onCancel}>{cancelText}</button>
            <button type="button" style={yesBtn} onClick={onConfirm}>{confirmText}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SavingModal
